import { keyframes } from '@mui/system';

const stripeMoveRTL = keyframes`
  from {
    background-position: 0 0;
  }
  to {
    background-position: -56px 0;
  }
`;

export function getBookingCardStatusStripeSx(color, opacity) {
  const stripeColor = `rgba(${color}, ${opacity})`;

  return {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 1,
    borderRadius: 'inherit',
    backgroundImage: `repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 10px,
      ${stripeColor} 10px,
      ${stripeColor} 20px
    )`,
    backgroundSize: '56px 56px',
    animation: `${stripeMoveRTL} 2s linear infinite`,
    willChange: 'background-position',
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  };
}
